module.exports = __webpack_public_path__ + "img/about-m-slide-4.80d0da45.jpg";